import baseUrl from '../baseUrl'
const { path } = baseUrl.path() // 开发与生产

export default {
  productList: path + '/base/product/page', // 分页查询产品信息
  generateProductCode: path + '/base/product/generateProductCode', // 根据产品名称生成产品编码
  createProduct: path + '/base/product', // 新增产品
  productDetail: path + '/base/product/detail/', // 产品详情
}